import { render, staticRenderFns } from "./PlaceTable_qy.vue?vue&type=template&id=1f35aafe&scoped=true"
import script from "./PlaceTable_qy.vue?vue&type=script&lang=js"
export * from "./PlaceTable_qy.vue?vue&type=script&lang=js"
import style0 from "./PlaceTable_qy.vue?vue&type=style&index=0&id=1f35aafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f35aafe",
  null
  
)

export default component.exports